if (!customElements.get('g-announcement-bar')) {
  class GAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === 'true';
      if (!enableSlider) return;
      this.initSlider();
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === 'true';
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector('.swiper-container');
      if (slideContainer) {
        this.slider = new GkifyLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        });
      }
    }
  }
  customElements.define('g-announcement-bar', GAnnouncementBar);
}
